import { Action } from '../../actions';
import {
  fetchedRemoteData,
  RemoteData,
  remoteDataError,
  unfetchedRemoteData,
  uninitializedRemoteData,
} from '../../helpers/remoteData';
export type ResetPasswordPage = {
  resetPasswordResult: RemoteData<string>;
};
const defaultState = {
  resetPasswordResult: uninitializedRemoteData<string>(),
};
export default function resetPasswordPageReducer(
  state: ResetPasswordPage = defaultState,
  action: Action,
): ResetPasswordPage {
  switch (action.type) {
    case 'RESET_PASSWORD_START':
      return Object.assign({}, state, {
        resetPasswordResult: unfetchedRemoteData<string>(),
      });
    case 'RESET_PASSWORD_SUCCESS':
      return Object.assign({}, state, {
        resetPasswordResult: fetchedRemoteData<string>(action.message),
      });
    case 'RESET_PASSWORD_FAIL':
      return Object.assign({}, state, {
        resetPasswordResult: remoteDataError<string>(action.message),
      });
    case 'SIGN_OUT_SUCCESS':
      return Object.assign({}, state, defaultState);
    default:
      return state;
  }
}
